(() => {
  'use strict';
  const initialized = new WeakSet();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(scope) {
    const candidates = scope.querySelectorAll('[data-v10-reveal]');
    candidates.forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      if (!('IntersectionObserver' in window) || reduced()) {
        section.classList.add('is-in-view');
        return;
      }
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            section.classList.add('is-in-view');
            observer.disconnect();
            break;
          }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => reveal(document), { once: true });
  else reveal(document);
  document.addEventListener('shopify:section:load', event => reveal(event.target));
})();
